import React, { useState } from "react";
import RightPanel from "./RightPanel";
import LeftPanel from "./LeftPanel";

interface MenuV2Props {
    categories: any[];
    groups: any[];
}

export default function MenuV2({ categories, groups }: MenuV2Props) {
    const [hoveredCategory, setHoveredCategory] = useState<any>(null);

    const isGroup = !(hoveredCategory?.children?.length > 0);
    const rightPanelItems = isGroup
        ? groups 
        : hoveredCategory.children;

    return (
        <div className="styles_MenuV2__Dqzo5">
            <div className="styles_MenuV2Wrapper__Q3ik_">
                <div 
                    className="styles_SubMenuContainer__rKcIG"
                    onMouseLeave={() => setHoveredCategory(null)}
                >
                    <LeftPanel 
                        items={categories} 
                        onHoverItem={setHoveredCategory} 
                    />
                    <RightPanel items={rightPanelItems} isGroup={isGroup} />
                </div>
            </div>
        </div>
    );
}

/* ================= ITEM ================= */

